import { Flex, Progress } from 'antd';
import { useTranslation } from 'react-i18next';
import { fontSize, lineHeight, primitiveColors, spacing, textColor } from '../../theming';
import { failureReasonKey } from '../../utils/vinExtraction';
import { monoFontFamily } from './vinExtractionStyles';
import { useNumberFormat } from './useNumberFormat';

const rowStyle = { display: 'grid', gridTemplateColumns: 'minmax(120px, 1fr) minmax(80px, 1fr) auto', gap: spacing[2] };

const reasonLabelStyle = { fontSize: fontSize.xs, lineHeight: lineHeight.md, color: textColor.primary };

const codeStyle = {
    fontFamily: monoFontFamily,
    fontSize: fontSize.xxs,
    lineHeight: lineHeight.sm,
    color: textColor.subtle,
};

const countStyle = { fontSize: fontSize.xs, lineHeight: lineHeight.md, fontWeight: 600, color: textColor.primary };

const shareStyle = { fontSize: fontSize.xxs, lineHeight: lineHeight.md, color: textColor.secondaryAlt };

/** One reason: its label and raw code, a bar of its share of the failed cars, then the count and share. */
const FailureReasonRow = ({ reason, count, share }) => {
    const { t } = useTranslation('vinExtraction');
    const { integer, oneDecimal } = useNumberFormat();
    const label = t(`stats.reasons.label.${failureReasonKey(reason)}`);
    const shareText = `${oneDecimal(share * 100)}%`;

    return (
        <div style={rowStyle} role="listitem" data-testid="vin-failure-reason">
            <Flex vertical style={{ minWidth: 0 }}>
                <span style={reasonLabelStyle}>{label}</span>
                <code style={codeStyle}>{reason}</code>
            </Flex>
            <Progress
                percent={Math.min(100, Math.max(0, share * 100))}
                showInfo={false}
                strokeColor={textColor.error}
                trailColor={primitiveColors.gray50}
                size="small"
                aria-label={t('stats.reasons.barAria', { label, percent: shareText })}
                style={{ margin: 0, alignSelf: 'center' }}
            />
            <Flex align="baseline" gap={spacing[0.5]} justify="end">
                <span style={countStyle}>{integer(count)}</span>
                <span style={shareStyle}>{shareText}</span>
            </Flex>
        </div>
    );
};

export default FailureReasonRow;
